package org.vreo.devicehub.features.settings.presentation.mainSettings

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

import androidx.lifecycle.ViewModel

import org.vreo.devicehub.features.core.domain.device.device.DeviceAuthentication

/**
 * Main settings view model
 * @param authentication user and target device authentication
 */
class MainSettingsViewModel(
    authentication: DeviceAuthentication,
) : ViewModel() {
    private val _state = MutableStateFlow(MainSettingsState(isDeviceActive = authentication.isDeviceActive))
    val state = _state.asStateFlow()
}